import { format } from 'date-fns';
import { format as formatTz, utcToZonedTime } from 'date-fns-tz';

export function readableDateTime(date: Date | string | undefined, textIfUndefined?: string): string {
  if (date === undefined) {
    return textIfUndefined ?? 'unknown';
  }
  return format(new Date(date), 'yyyy-MM-dd HH:mm');
}

export function readableDate(date: Date | string | undefined, textIfUndefined?: string): string {
  if (date === undefined) {
    return textIfUndefined ?? 'unknown';
  }
  return format(new Date(date), 'yyyy-MM-dd');
}

export function birthDate(date: Date): string {
  if (date && !(date instanceof Date)) {
    date = new Date(date);
  }
  return date?.toISOString()?.split('T')[0] ?? 'unknown';
}

export const formatAsUTCDate = (date: string | Date, fmt: string) =>
  formatTz(utcToZonedTime(date, 'UTC'), fmt, { timeZone: 'UTC' });
